// LINE認証後の電話番号入力（配送に電話必須のためSMS認証を行う）。
// 既存(ログイン)で試し、未登録なら新規として送信する自動判定。
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';
import { toast } from 'react-toastify';
import { Post } from '../compornents/Post';
import { Analytics } from '../compornents/Analytics';

const KEY = 'yt~z7ESU6J~tLB7ppw(CLD8WddX9PNsr6DH';

export function LinePhone() {
  const navigate = useNavigate();
  const [tel, setTel] = useState('');
  const [Loading, openL, closeL] = useModal('root', {});

  let profile = null;
  try { profile = JSON.parse(sessionStorage.getItem('line_profile') || 'null'); } catch (e) { profile = null; }

  // LINEフローでなければ弾く（render中のnavigateは避ける）
  useEffect(() => {
    if (!sessionStorage.getItem('line_token')) navigate('/login');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function submit() {
    openL();
    try {
    // まずログイン(既存)として送信、未登録(E025)なら新規として再送
    let res = await Post('public', '/auth/send_sms.php', { key: KEY, tel, is_register: 0 });
    let isRegister = 0;
    if (res.result !== 1 && res.error_code === 'E025') {
      res = await Post('public', '/auth/send_sms.php', { key: KEY, tel, is_register: 1 });
      isRegister = 1;
    }
    closeL();
    if (res.result === 1) {
      sessionStorage.setItem('line_phone_cid', String(res.customer_id));
      sessionStorage.setItem('line_phone_isreg', String(isRegister));
      navigate('/line/phone/auth');
    } else {
      toast.error(res.error_message || '送信に失敗しました');
    }
    } catch (e) {
      console.error('[LinePhone]', e);
      toast.error('エラーが発生しました。もう一度お試しください');
    } finally { closeL(); }
  }

  return (
    <div>
      <Analytics title="LINE連携・電話番号入力" />
      <div className="Register m-auto">
        <div className="App-tel">
          <div className="auth-logo">
            <img src="/img/header_logo.png" alt="LAUNDRY PACK" />
          </div>
          <div className="line-greet">
            {profile?.picture && <img className="line-greet_avatar" src={profile.picture} alt="" />}
            <div>
              {profile?.name && <div className="line-greet_name">{profile.name} さん</div>}
              <div className="line-greet_badge">LINE連携済み</div>
            </div>
          </div>
          <div className="tel-title">電話番号の確認</div>
          <div className="App-comment">
            お荷物の集荷・お届けに使用します。携帯電話のSMSで認証を行います。電話番号が他のお客様に公開されることはありません。
          </div>
          <div className="App-telno">
            <input type="tel" value={tel} onChange={(e) => setTel(e.target.value)} placeholder="例）09012345678" className="form-control" />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
            {tel.length === 11
              ? <button className="button-next" onClick={submit}>認証番号を送る</button>
              : <button className="button-next-g">認証番号を送る</button>}
          </div>
        </div>
      </div>
      <Loading>
        <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
          {/* focus-trap対策: モーダル内にtabbable要素が無いと例外で白画面になる(Login.jsxと同じ対策) */}
          <button onClick={closeL} className="hide">閉じる</button>
          <div><TailSpin stroke="#000" /></div>
          <div>処理中です</div>
        </div>
      </Loading>
    </div>
  );
}

export default LinePhone;
